const pendingSslKey = 'certinite:pending-ssl-purchase';
const maxAge = 24 * 60 * 60 * 1000;
const isPurchaseReturn = (safe: string) => ['/dashboard/ssl/buy', '/dashboard/ssl-monitor', '/dashboard/agency'].includes(safe.split('?')[0])
  || safe.split('?')[0] === '/dashboard' && new URLSearchParams(safe.split('?')[1]).get('install') === 'choose';

/** Only allow navigation within this application's authenticated dashboard. */
export function safeDashboardReturn(value: string | null): string | null {
  if (!value) return null;
  try {
    const origin = window.location.origin;
    const url = new URL(value, origin);
    if (url.origin === origin && (url.pathname === '/dashboard' || url.pathname.startsWith('/dashboard/')))
      return url.pathname + url.search;
  } catch { /* Malformed or external return links are ignored. */ }
  return null;
}

export function rememberSslPurchase(destination: string | null) {
  const safe = safeDashboardReturn(destination);
  if (!safe || !isPurchaseReturn(safe)) return;
  try { localStorage.setItem(pendingSslKey, JSON.stringify({ destination: safe, expires: Date.now() + maxAge })); }
  catch { /* Registration still works when storage is unavailable. */ }
}

export function pendingSslPurchase(): string | null {
  try {
    const saved = JSON.parse(localStorage.getItem(pendingSslKey) ?? 'null');
    if (!saved || typeof saved.expires !== 'number' || saved.expires <= Date.now()) return null;
    const safe = safeDashboardReturn(saved.destination);
    return safe && isPurchaseReturn(safe) ? safe : null;
  } catch { return null; }
}

export function clearSslPurchase() {
  try { localStorage.removeItem(pendingSslKey); } catch { /* Optional continuation state. */ }
}

export function authContinuationPath(page: 'login' | 'register', destination: string | null, isTr: boolean) {
  const safe = safeDashboardReturn(destination);
  return `${isTr ? '/tr' : ''}/${page}${safe ? `?returnTo=${encodeURIComponent(safe)}` : ''}`;
}
